"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.I18nManager = void 0;
var II18nManager_1 = require("../II18nManager");
var inversify_1 = require("inversify");
var EventEmitter_1 = require("./EventEmitter");
var react_intl_1 = require("react-intl");
var TypeDefs_1 = require("../../TypeDefs");
var I18nManager = exports.I18nManager = /** @class */ (function (_super) {
    __extends(I18nManager, _super);
    function I18nManager(userSettingsStorage) {
        var _this = _super.call(this) || this;
        _this.messages = {};
        _this.availableLocales = [];
        _this.userSettingsStorage = userSettingsStorage;
        return _this;
    }
    I18nManager_1 = I18nManager;
    I18nManager.prototype.setAvailableLocales = function (locales) {
        var _this = this;
        this.availableLocales = [];
        Object.keys(locales).forEach(function (locale) {
            _this.addAvailableLocale(locale, locales[locale]);
        });
    };
    I18nManager.prototype.getAvailableLocales = function () {
        return this.availableLocales;
    };
    I18nManager.prototype.addAvailableLocale = function (locale, localeData) {
        this.availableLocales.push(locale);
        (0, react_intl_1.addLocaleData)(localeData);
        this.emit(II18nManager_1.I18nEvent.Change);
    };
    I18nManager.prototype.getCurrentLocale = function () {
        if (!this.userSettingsStorage.has(I18nManager_1.LOCALEKEY)) {
            // Locale not persisted previously - try to bind from browser settings
            if (this.isLocaleAvailable(navigator.language)) {
                return navigator.language;
            }
            return this.getDefaultLocale();
        }
        // Locale persisted
        var persistedLocale = this.userSettingsStorage.get(I18nManager_1.LOCALEKEY);
        if (this.isLocaleAvailable(persistedLocale)) {
            return persistedLocale;
        }
        return this.getDefaultLocale();
    };
    I18nManager.prototype.setCurrentLocale = function (locale, fallback) {
        if (this.isLocaleAvailable(locale)) {
            this.userSettingsStorage.set(I18nManager_1.LOCALEKEY, locale);
        }
        else {
            if (fallback && this.availableLocales.length > 0) {
                this.userSettingsStorage.set(I18nManager_1.LOCALEKEY, this.getDefaultLocale());
            }
            throw Error("Locale ".concat(locale, " not available"));
        }
        this.emit(II18nManager_1.I18nEvent.LocaleChange, locale);
        this.emit(II18nManager_1.I18nEvent.Change);
    };
    I18nManager.prototype.addMessages = function (messagesPerLocale) {
        // Merge current messages with added
        for (var locale in messagesPerLocale) {
            if (messagesPerLocale.hasOwnProperty(locale)) {
                this.addMessagesForLocale(locale, messagesPerLocale[locale]);
            }
        }
    };
    I18nManager.prototype.addMessagesForLocale = function (locale, messages) {
        if (!this.messages[locale]) {
            this.messages[locale] = {};
        }
        // Merge maps
        for (var id in messages) {
            if (messages.hasOwnProperty(id)) {
                this.messages[locale][id] = messages[id];
            }
        }
        this.emit(II18nManager_1.I18nEvent.MessagesChange, locale);
        this.emit(II18nManager_1.I18nEvent.Change);
    };
    I18nManager.prototype.getMessagesForLocale = function (locale) {
        if (!this.messages[locale]) {
            this.messages[locale] = {};
        }
        return this.messages[locale];
    };
    I18nManager.prototype.getMessagesForCurrentLocale = function () {
        return this.getMessagesForLocale(this.getCurrentLocale());
    };
    I18nManager.prototype.getDefaultLocale = function () {
        return this.availableLocales[0];
    };
    I18nManager.prototype.isLocaleAvailable = function (locale) {
        return this.availableLocales.indexOf(locale) > -1;
    };
    var I18nManager_1;
    I18nManager.LOCALEKEY = "I18nManager.Locale";
    I18nManager = I18nManager_1 = __decorate([
        (0, inversify_1.injectable)(),
        __param(0, (0, inversify_1.inject)(TypeDefs_1.TypeDefs.UserSettingsStorage)),
        __metadata("design:paramtypes", [Object])
    ], I18nManager);
    return I18nManager;
}(EventEmitter_1.EventEmitter));
//# sourceMappingURL=I18nManager.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/core/dist/services/impl/I18nManager.js
// module id = 565
// module chunks = 0